<template>
  <b-row align-h="between">
    <b-col cols="12" sm="4" md="6" lg="8">
      <b class="b-inline-block">{{ lca }} 배출량 상세</b>
    </b-col>
    <b-col cols="12" sm="8" md="6" lg="4">
      <b-row align-h="between">
        <b-col class="d-flex justify-content-between">
          <span class="d-inline-block">연간 총배출량 ({{ lca }}): </span>
          <span class="d-inline-block"> {{ formatNumber(total) }} tCO2e </span>
        </b-col>
      </b-row>
      <b-row align-h="between">
        <b-col class="d-flex justify-content-between">
          <span class="d-inline-block">단위 제품당 배출량 ({{ lca }}): </span>
          <span class="d-inline-block"> {{ formatNumber(totalPerProduction) }} tCO2e</span>
        </b-col>
      </b-row>
      <b-row align-h="between">
        <b-col class="d-flex justify-content-between">
          <span class="d-inline-block">총배출량 순위: </span>
          <span class="d-inline-block">{{ rank ? rank.rank : '-' }} / {{ rank ? rank.count : '-' }}</span>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "LcaDetailHeader",
  props: ['lca', 'total', 'totalPerProduction', 'rank']
}
</script>